<template>
  <div class="circle">
    <div class="big-title wow fadeInUp"><img src="https://static.worldaic.com.cn/2024/web/static/images/c.png" alt="">amp 创见</div>
    <div class="tips wow fadeInUp">
      <p>{{ $t('where1') }}</p>
      <p><big>1000+</big>{{ $t('where2') }}</p><p>{{ $t('where3') }}</p>
    </div>
    <ul class="avatar" v-if="list.length">
      <li :class="avatarIndex(index)" v-for="(item, index) in list" :key="index">
        <img :src="item.photoImgUrl" alt="" @mouseenter="stop" @mouseleave="animate" @click="link(item, index)">
        <div class="mask" v-if="['a5', 'a6', 'a8', 'a5-5', 'a6-5', 'a7-5'].includes(avatarIndex(index))">
          <div class="txt">
            <big class="ellipsis1">{{ item['name' + En] }}</big>
            <small class="ellipsis1">{{ item['company' + En] }}</small>
            <small class="ellipsis1">{{ item['position' + En] }}</small>
          </div>
        </div>
        <div class="profile" v-if="['a7', 'a6-5', 'a7-5'].includes(avatarIndex(index))" :style="{ opacity: ['a7'].includes(avatarIndex(index)) ? 1: 0 }">
          <div class="tip" v-if="item['soundbite' + En]"><sup>“</sup> <span>{{ item['soundbite' + En] }}</span> <sub>”</sub></div>
          <div class="txt">
            <big class="ellipsis1">{{ item['name' + En] }}</big>
            <small class="ellipsis1">{{ item['company' + En] }}</small>
            <small class="ellipsis1">{{ item['position' + En] }}</small>
          </div>
        </div>
      </li>
    </ul>
    <ul class="dots">
      <li v-for="item in 9" :key="item" :class="dotIndex(item)"></li>
    </ul>
  </div>
</template>

<script>
import protal from "@/api/protal";

export default {
  name: 'mycircle',
  props: {
    dateList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      list: [],
      num: 0,
      timer: null,
      timer1: null,
      flag: true,
      yearUuid: '',
      typeList: [],
      total: 0
    }
  },
  watch: {
    dateList(v) {
      this.yearUuid = v[0].yearUuid
      this.getData()
    },
  },
  mounted() {
    this.animate()
  },
  computed: {
    avatarIndex(index) {
      return index => {
        if ((index + this.num) >= this.list.length) {
          return 'a' + ((index + this.num) % this.list.length).toString().replace('.', '-')
        } else {
          return 'a' + (index + this.num).toString().replace('.', '-')
        }
      }
    },
    dotIndex(index) {
      return index => {
        return 'a' + ((index + this.num) % 9).toString().replace('.', '-')
      }
    },
  },
  methods: {
    link(item, index) {
      this.$jsAPI('track','homeClick',
          {
            'floor_var': 'Camp创见',
            'position_var': `无`,
            'flowName_var': item.name,
            'industryFirstCate_var': '无',
            'industrySecCate_var': '无',
            'tabName_var': '无',
          }
      );
      gio('track','homeClick',
          {
            'floor_var': 'Camp创见',
            'position_var': `无`,
            'flowName_var': item.name,
            'industryCate_var': '无',
            'industryFirstCate_var': '无',
            'tabName_var': '无',
          }
      );
      this.$router.push('/juzheng')
    },
    animate() {
      if (this.flag) {
        this.num += 0.5
        this.timer = setInterval(() => {
          this.num += 0.5
        }, 3000)

        this.flag = false
        clearTimeout(this.timer1)
        this.timer1 = setTimeout(() => {
          this.flag = true
          if (!this.timer) {
            this.animate()
          }
        }, 3000)
      } else {
        this.timer = null
      }
    },
    stop() {
      clearInterval(this.timer)
      if (!this.flag) {
        this.timer = 1
      }
    },
    showModalFn(item) {
      this.showModal = true
      this.getInfo(item.uuid)
    },
    getInfo(uuid) {
      protal.queryOfficialFrontGuest(uuid).then(res => {
        this.guestDetail = res.data || {}
      })
    },
    tabClick() {
      this.pageNum = 1;
      this.getData();
    },
    getData() {
      // 活动嘉宾
      protal
        .queryOfficialSpeechGuestList({
          recommendSts: 0,
          pageNum: 1,
          pageSize: 9999,
          // yearUuid: this.yearUuid
        })
        .then((res) => {
          this.total = res.total || 0
          this.list = res.data || []
        }).catch(err => {
          this.list = []
        })
    },
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .circle {
    position: relative;
    width: 100%;
    height: 12.4rem;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/circle-bg.jpg");
    background-size: cover;
    padding: 1.2rem 1.1rem 0;
    display: flex;
    justify-content: space-between;
    text-align: left;
    overflow: hidden;
    margin-top: -0.3rem;

    .tips {
      font-size: .4rem;
      font-weight: 400;
      color: #595757;
      line-height: .64rem;
      position: absolute;
      left: 1.1rem;
      top: 2.4rem;

      big {
        font-weight: bold;
        font-size: .64rem;
      }
    }

    .avatar {

      li {
        position: absolute;
        cursor: pointer;
        opacity: 0;
        transition: 3s linear;
        left: 16rem;
        top: 5.64rem;
        z-index: 1;

        .mask {
          position: absolute;
          left: .1rem;
          top: .1rem;
          right: .1rem;
          bottom: .1rem;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 50%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 0 .2rem;
          opacity: 0;
          transition: 3s;
          pointer-events: none;

          big {
            font-size: .36rem;
            color: #fff;
            display: block;
            margin-bottom: .1rem;
          }

          small {
            font-size: .24rem;
            color: rgba(255, 255, 255, .9);
            line-height: 1.8;
            display: block;
          }
        }

        &:hover {
          .mask {
            opacity: 1;
          }
        }

        .profile {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 5.2rem;
          background: linear-gradient(175deg, #3099F5 0%, rgba(196, 2, 228, 0.5) 100%);
          border-radius: 1.5rem;
          z-index: -1;
          padding: 3.2rem .2rem 0 .56rem;
          transition: 3s;

          .tip {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -0.94rem;
            height: .7rem;
            display: flex;
            align-items: center;
            border-radius: .35rem;
            background: rgba(255, 255, 255, 0);
            box-shadow: 0px 2px 8px 0px rgba(179, 179, 179, 0.2), inset 0px 0px 40px 0px #FFFFFF;
            border: 2px solid rgba(255, 255, 255, 0.4);
            white-space: nowrap;
            font-size: .28rem;
            color: #FF7A00;
            line-height: 1;
            background: linear-gradient(to right, RGBA(36, 83, 180, 1) 0%, #4F53B8 19%, #9553BE 50%, #DA8E86 85%, RGBA(247, 167, 110, 1) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            padding: 0 .2rem;
            font-family: sybold;

            &::before {
              content: "";
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              top: .66rem;
              border-top: .18rem solid RGBA(240, 241, 241, 1);
              border-left: .25rem solid transparent;
              border-right: .25rem solid transparent;
            }

            sup {
              font-size: .4rem;
              margin-top: -0.1rem;
              margin-right: 0.1rem;
            }

            sub {
              font-size: .4rem;
              margin-top: 0.4rem;
              margin-left: 0.1rem;
            }
          }

          big {
            font-size: .36rem;
            line-height: .54rem;
            color: #fff;
            display: block;
          }

          small {
            font-size: .24rem;
            color: #fff;
            line-height: 1.6;
            display: block;
          }
        }

        img {
          width: 3rem;
          height: 3rem;
          border-radius: 50%;
          display: block;
          border: .1rem solid rgba(255, 255, 255, 0.6);
          transition: 3s;
        }

        z-index: 1;
        
        &.a0 {
          left: 0.2rem;
          top: 6.9rem;
          opacity: 0;

          img {
            width: 1rem;
            height: 1rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a0-5 {
          left: 0.5rem;
          top: 5.9rem;
          opacity: 0;

          img {
            width: 1.6rem;
            height: 1.6rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a1 {
          left: 1.15rem;
          top: 6.9rem;
          opacity: 1;

          img {
            width: 1.6rem;
            height: 1.6rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a1-5 {
          left: 2.15rem;
          top: 7.9rem;
          opacity: 1;

          img {
            width: 1.6rem;
            height: 1.6rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a2 {
          left: 3.22rem;
          top: 7.79rem;
          opacity: 1;

          img {
            width: 1.8rem;
            height: 1.8rem;
            border: .1rem solid rgba(255, 255, 255, 0.3);
          }
        }
        
        &.a2-5 {
          left: 3rem;
          top: 6.79rem;
          opacity: 1;

          img {
            width: 1.8rem;
            height: 1.8rem;
            border: .1rem solid rgba(255, 255, 255, 0.3);
          }
        }
        
        &.a3 {
          left: 4.83rem;
          top: 6.29rem;
          opacity: 1;

          img {
            width: 2.2rem;
            height: 2.2rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a3-5 {
          left: 4.63rem;
          top: 7.29rem;
          opacity: 1;

          img {
            width: 2.2rem;
            height: 2.2rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a4 {
          left: 6.42rem;
          top: 7.99rem;
          opacity: 1;

          img {
            width: 2.4rem;
            height: 2.4rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a4-5 {
          left: 6.62rem;
          top: 6.99rem;
          opacity: 1;

          img {
            width: 2.4rem;
            height: 2.4rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a5 {
          left: 8.36rem;
          top: 5.64rem;
          opacity: 1;

          img {
            width: 3rem;
            height: 3rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a5-5 {
          left: 8.66rem;
          top: 3.64rem;
          opacity: 1;

          img {
            width: 2.6rem;
            height: 2.6rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a6 {
          left: 11.02rem;
          top: 7.84rem;
          opacity: 1;

          img {
            width: 3rem;
            height: 3rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a6-5 {
          left: 11.02rem;
          top: 4rem;
          opacity: 1;
          z-index: 2;

          img {
            width: 2.6rem;
            height: 2.6rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a7 {
          left: 11.02rem;
          top: 2.56rem;
          opacity: 1;
          z-index: 2;

          img {
            width: 3rem;
            height: 3rem;
            border: .1rem solid rgba(255, 255, 255, 1);
          }
        }
        
        &.a7-5 {
          left: 12.02rem;
          top: 4rem;
          opacity: 1;
          z-index: 0;

          img {
            width: 2.6rem;
            height: 2.6rem;
            border: .1rem solid rgba(255, 255, 255, .6);
          }
        }
        
        &.a8 {
          left: 13.7rem;
          top: 5.64rem;
          opacity: 1;

          img {
            width: 3rem;
            height: 3rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a8-5 {
          left: 16rem;
          top: 5.64rem;
          opacity: 0;

          img {
            width: 2.6rem;
            height: 2.6rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }

      }
    }

    .dots {
      
      li {
        position: absolute;
        transition: 3s linear;

        &.a0 {
          left: -1rem;
          top: 8.1rem;
          width: .7rem;
          height: .7rem;
          border-radius: 50%;
          opacity: 0;
        }

        &.a0-5 {
          left: 1rem;
          top: 6.8rem;
          width: .7rem;
          height: .7rem;
          border-radius: 50%;
          opacity: 1;
        }

        &.a8 {
          left: 20rem;
          top: 7.8rem;
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          background: RGBA(228, 148, 137, 1);
          opacity: 0;
        }

        &.a8-5 {
          left: 20rem;
          top: 7.8rem;
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          background: RGBA(228, 148, 137, 1);
          opacity: 0;
        }

        &.a1 {
          left: 2.56rem;
          top: 8.1rem;
          width: .7rem;
          height: .7rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
        }

        &.a1-5 {
          left: 4rem;
          top: 8.3rem;
          width: .7rem;
          height: .7rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
        }
        
        &.a2 {
          left: 3.8rem;
          top: 7.2rem;
          width: .56rem;
          height: .56rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
        }
        
        &.a2-5 {
          left: 5rem;
          top: 7.2rem;
          width: .56rem;
          height: .56rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
        }
        
        &.a3 {
          left: 5.3rem;
          top: 8.6rem;
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          background: RGBA(119, 100, 197, 1);
        }
        
        &.a3-5 {
          left: 7.6rem;
          top: 8.8rem;
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          background: RGBA(119, 100, 197, 1);
        }
        
        &.a4 {
          left: 7.6rem;
          top: 7.2rem;
          width: 0.7rem;
          height: 0.7rem;
          border-radius: 50%;
          background: RGBA(138, 88, 196, 1);
        }
        
        &.a4-5 {
          left: 9.1rem;
          top: 6.2rem;
          width: 0.7rem;
          height: 0.7rem;
          border-radius: 50%;
          background: RGBA(138, 88, 196, 1);
        }
        
        &.a5 {
          left: 9.1rem;
          top: 8.9rem;
          width: 1.8rem;
          height: 1.8rem;
          border-radius: 50%;
          background: RGBA(158, 75, 195, 1);
        }
        
        &.a5-5 {
          left: 11.1rem;
          top: 6.8rem;
          width: 1.4rem;
          height: 1.4rem;
          border-radius: 50%;
          background: RGBA(158, 75, 195, 1);
        }
        
        &.a6 {
          left: 14.1rem;
          top: 8.6rem;
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          background: RGBA(205, 122, 159, 1);
        }
        
        &.a6-5 {
          left: 15.1rem;
          top: 7rem;
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          background: RGBA(205, 122, 159, 1);
        }
        
        &.a7 {
          left: 16.3rem;
          top: 7.8rem;
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          background: RGBA(228, 148, 137, 1);
        }
        
        &.a7-5 {
          left: 20rem;
          top: 6.8rem;
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          background: RGBA(228, 148, 137, 1);
          opacity: 0;
        }

      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .circle {
    position: relative;
    width: 100%;
    height: 12.4rem;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/circle-bg-wap.jpg");
    background-size: 100% 100%;
    padding: 1.54rem 0;
    overflow: hidden;

    .big-title {
      margin: 0 .4rem;
    }

    .tips {
      font-size: .32rem;
      font-weight: 400;
      color: #595757;
      line-height: .48rem;
      padding: 0 .4rem;
      margin-top: .52rem;

      * {
        display: inline-block;
      }

      big {
        font-weight: bold;
        font-size: .52rem;
      }
    }

    .avatar {

      li {
        position: absolute;
        cursor: pointer;
        opacity: 0;
        transition: 3s linear;
        left: 16rem;
        top: 5.64rem;
        z-index: 2;

        .mask {
          position: absolute;
          left: .1rem;
          top: .1rem;
          right: .1rem;
          bottom: .1rem;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 50%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 0 .2rem;
          opacity: 0;
          transition: 3s;

          &:hover {
            opacity: 1;
          }

          big {
            font-size: .36rem;
            color: #fff;
            display: block;
            margin-bottom: 0.1rem;
          }

          small {
            font-size: .24rem;
            color: rgba(255, 255, 255, .9);
            line-height: 1.8;
            display: block;
          }
        }

        .profile {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 4.5rem;
          background: linear-gradient(175deg, #3099F5 0%, rgba(196, 2, 228, 0.5) 100%);
          border-radius: 1.5rem;
          z-index: -1;
          padding: 2.8rem .2rem 0 .56rem;
          transition: 3s;

          .tip {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -1rem;
            height: .7rem;
            align-items: center;
            border-radius: .35rem;
            border: 2px solid rgba(255, 255, 255, 0.4);
            white-space: nowrap;
            font-size: .26rem;
            color: #FF7A00;
            line-height: 1;
            box-shadow: 0px .02rem .08rem 0px rgba(179, 179, 179, 0.2), inset 0px 0px .4rem 0px #FFFFFF;
            background: linear-gradient(to right, #2453B4 0%, #4F53B8 19%, #9553BE 50%, #DA8E86 85%, #F7A76E 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-family: sybold;
            padding: 0 .2rem;

            &::before {
              content: "";
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              top: .66rem;
              border-top: .18rem solid RGBA(240, 241, 241, 1);
              border-left: .25rem solid transparent;
              border-right: .25rem solid transparent;
            }

            sup {
              font-size: .4rem;
              margin-top: 0;
            }

            sub {
              font-size: .4rem;
              margin-top: 0rem;
            }
          }

          big {
            font-size: .36rem;
            color: #fff;
            display: block;
            margin-bottom: .1rem;
          }

          small {
            font-size: .24rem;
            color: #fff;
            line-height: 1.8;
            display: block;
          }
        }

        img {
          width: 3rem;
          height: 3rem;
          border-radius: 50%;
          display: block;
          transition: 3s linear;
        }
        
        &.a0, &.a1, &.a2, &.a3, &.a0-5, &.a1-5, &.a2-5, &.a3-5 {
          left: -3rem;
          top: 6.9rem;

          img {
            width: 1rem;
            height: 1rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a10, &.a10-5 {
          left: 10rem;
          top: 6.9rem;

          img {
            width: 1rem;
            height: 1rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a4 {
          left: -0.8rem;
          top: 8.82rem;
          opacity: 1;

          img {
            width: 1.6rem;
            height: 1.6rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a4-5 {
          left: 0rem;
          top: 8rem;
          opacity: 1;

          img {
            width: 1.6rem;
            height: 1.6rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a5 {
          left: .6rem;
          top: 7.32rem;
          opacity: 1;

          img {
            width: 2.2rem;
            height: 2.2rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a5-5 {
          left: 1rem;
          top: 8.32rem;
          opacity: 1;

          img {
            width: 2.2rem;
            height: 2.2rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a6 {
          left: 2.55rem;
          top: 8.73rem;
          opacity: 1;
          z-index: 1;

          img {
            width: 2.2rem;
            height: 2.2rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a6-5 {
          left: 2.55rem;
          top: 7rem;
          opacity: 1;
          z-index: 1;

          img {
            width: 2.2rem;
            height: 2.2rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a7 {
          left: 2.45rem;
          top: 4.5rem;
          opacity: 1;
          z-index: 1;

          img {
            width: 2.6rem;
            height: 2.6rem;
            border: .1rem solid rgba(255, 255, 255, 1);
          }
        }
        
        &.a7-5 {
          left: 3rem;
          top: 6rem;
          opacity: 1;
          z-index: 1;

          img {
            width: 2.6rem;
            height: 2.6rem;
            border: .1rem solid rgba(255, 255, 255, 1);
          }
        }
        
        &.a8 {
          left: 4.7rem;
          top: 7.32rem;
          opacity: 1;

          img {
            width: 2.4rem;
            height: 2.4rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a8-5 {
          left: 5rem;
          top: 5.22rem;
          opacity: 1;

          img {
            width: 2.4rem;
            height: 2.4rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a9 {
          left: 6.22rem;
          top: 5.64rem;
          opacity: 1;

          img {
            width: 1.8rem;
            height: 1.8rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
        
        &.a9-5 {
          left: 7.5rem;
          top: 7.64rem;
          opacity: 0;

          img {
            width: 1.8rem;
            height: 1.8rem;
            border: .1rem solid rgba(255, 255, 255, 0.6);
          }
        }
      }
    }

    .dots {
      
      li {
        position: absolute;
        transition: 3s linear;
        
        &.a1 {
          left: -2rem;
          top: 8.6rem;
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
          opacity: 0;
        }
        
        &.a1-5 {
          left: -2rem;
          top: 8.6rem;
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
          opacity: 0;
        }
        
        &.a2 {
          left: -0.5rem;
          top: 7.6rem;
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          background: RGBA(119, 100, 197, 1);
        }
        
        &.a2-5 {
          left: 0.5rem;
          top: 7rem;
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          background: RGBA(119, 100, 197, 1);
        }
        
        &.a3 {
          left: 1rem;
          top: 8rem;
          width: .8rem;
          height: .8rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
        }
        
        &.a3-5 {
          left: 3rem;
          top: 7rem;
          width: .8rem;
          height: .8rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
        }
        
        &.a4 {
          left: 5.1rem;
          top: 10rem;
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
        }
        
        &.a4-5 {
          left: 5.6rem;
          top: 7rem;
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
        }
        
        &.a5 {
          left: 7.1rem;
          top: 7.8rem;
          width: .8rem;
          height: .8rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
        }
        
        &.a5-5 {
          left: 7.5rem;
          top: 7.8rem;
          width: .8rem;
          height: .8rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
          opacity: 0;
        }
        
        &.a6 {
          left: 8rem;
          top: 7.8rem;
          width: .8rem;
          height: .8rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
          opacity: 0;
        }
        
        &.a6-5 {
          left: 8rem;
          top: 7.8rem;
          width: .8rem;
          height: .8rem;
          border-radius: 50%;
          background: RGBA(107, 123, 194, 1);
          opacity: 0;
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/mycircle.vue